import React from 'react';
import '../../../App.css';
import {Link} from 'react-router-dom';

export default function Drawing() {
    return(
        <>
            <Link to="/DigitalPortfolio/hobbies" className="nav-back">
                    <div className='nav-back-text'>{"<"}Back</div>
                </Link>
            <h1 className='header'>Drawing</h1>
        </>
    )
}